itsoftApp.createModule("validationCustom", function() {

    if ($(".input__value--email").length) {

        /*Email*/
        var pattern =  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        $(".contact-map__form").submit(function(e) {
            $(".input-validation").each(function() {
                if ($(this).val().length < 1) {
                    var th = $(this);
                    th.css({"background":"rgba(255,0,0,0.3)"});
                    setTimeout(function() {
                        $(".input-validation").css({"background":"rgba(255,255,255,0)"});
                    },400)
                    th.focus();
                    scrollTo();
                    e.preventDefault();
                    return false;
                }
            })
            var mail = $(this).closest("form").find(".input__value--email");
            if (mail.val().search(pattern) == 0) {
                //console.log("true");
            }
            else {
                scrollTo();
                mail.parent(".input").css({"background":"rgba(255,0,0,0.3)"});
                setTimeout(function() {
                    mail.parent(".input").css({"background":"rgba(255,255,255,0)"});
                },400)
                mail.focus();
                e.preventDefault();
                return false;
            }
            if ($(".textarea__area").val().length < 1) {
                $(".textarea__area").css({"background":"rgba(255,0,0,0.3)"});
                setTimeout(function() {
                    $(".textarea__area").css({"background":"rgba(255,255,255,1)"});
                },400)
                $(".textarea__area").focus();
                e.preventDefault();
                return false;
            }
            e.preventDefault();
            return false;
        });

    }

    function scrollTo() {
        $("html").stop().animate({ scrollTop: $(".contact-map__form-section").offset().top}, 300);
    }

});
